import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { login } from '../../actions'
import md5Hex from 'md5-hex'
import { XCircleIcon } from '@heroicons/react/20/solid'
import { PulseLoader } from 'react-spinners'
import { Link } from 'react-bootstrap/lib/Navbar'
import ForgotPasswordModal from './ForgotPasswordModal'

const SignInForm = (props) => {
  //props
  const {dispatch, viewer} = props;
  const {login_feedback, login_is_loading, server} = viewer;
  //state
  const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
  //route
  const navigate = useNavigate();
  const location = useLocation();
  let redirectRoute = viewer.redirect_page !== null ? viewer.redirect_page : '/';
  
	const onHandleInput = (event) => {
    switch (event.target.id) {
      case 'password':
        setPassword(event.target.value);
        break;
      case 'username':
        setUsername(event.target.value);
        break;
      default:
        return;
    }
	};

  const handleSignIn = async (e) => {	
    e.preventDefault();
    await dispatch(login(username, md5Hex(password), ''));
	};


  let [forgotPwModalOpen, setForgotPwModalOpen] = useState(false);

  const handleForgotPasswordModalToggle = () => {
    setForgotPwModalOpen(!forgotPwModalOpen);
  };

  if (login_feedback === 'none') {
    if(location.pathname === '/login') {
      navigate(redirectRoute);
      window.location.reload();
    }
    else {
      //refresh page to update login modal
      window.location.reload();
    }
  }
  else {
    return (
      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
      

        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-4 px-4  sm:px-10">
            {/* Login error feedback */}
            {login_feedback !== null
              ?
              <div className="rounded-md bg-red-50 p-4">
              <div className="flex">
                  <div className="flex-shrink-0">
                    <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3">
                    {login_feedback === "Incorrect password"
                    ?
                    <h3 className="text-sm font-medium text-red-800">
                      <FormattedMessage id='login.incorrect_password' defaultMessage="Incorrect password" />
                    </h3>
                    :
                    login_feedback === "Username not found"
                    ?
                    <h3 className="text-sm font-medium text-red-800">
                      <FormattedMessage id='login.not_found' defaultMessage="Username not found" />
                    </h3>
                    : null
                    }
                    <div className="mt-2 text-sm text-red-700 hidden"></div>
                </div>
                </div>
              </div>
              : null
            }

            {/* form */}
            <form className="space-y-6" action="#" method="POST" onSubmit={(e) => handleSignIn(e)}>
              <div className='my-2'>
                <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                <FormattedMessage id="login.username_email" defaultMessage="Username or Email" />
                </label>
                <div className="mt-1">
                  <input
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="username"
                    required
                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                    onChange={(e) => onHandleInput(e)}
                    value={username}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                <FormattedMessage id="login.password" defaultMessage="Password" />
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                    onChange={(e) => onHandleInput(e)}
                    value={password}
                  />
                </div>
              </div>

            

              <div>
                {login_is_loading
                ? 
                <button className="flex w-full justify-center border border-transparent bg-[#1A658F] py-4 px-6 rounded-md text-md font-medium text-white shadow-sm"
                    type="submit"
                    disabled={true}
                >
                  <PulseLoader color='white' size={12} />
                </button>
                : (username.length > 0 && password.length > 0)
                ?
                <button className="flex w-full justify-center border border-transparent bg-[#1A658F] py-4 px-6 rounded-md text-sm font-medium text-white shadow-sm hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2"
                  type="submit"
                >
                  <FormattedMessage id="login.sign_in" defaultMessage="Sign In" />
                </button>
                :
                <button className='flex w-full justify-center border border-transparent bg-gray-300 py-4 px-6 rounded-md text-sm font-medium text-white shadow-sm'
                  disabled
                >
                  <FormattedMessage id="login.sign_in" defaultMessage="Sign In" />
                </button>
                }

                <div className="items-center justify-between space-y-4 sm:space-y-2 my-8">
                <div className="text-base min-w-fit">
                  <button href={`${server}reset_password.php`} className="font-medium text-blue-600 hover:text-blue-500 hover:underline"
                    onClick={(e) => {
                      e.preventDefault();
                      handleForgotPasswordModalToggle();
                    }
                  }>
                    <FormattedMessage id="login.forget" defaultMessage="Forgot your password?" />
                  </button>
                </div>
                <div>
                  <Link href="/" className="font-medium text-blue-600 hover:text-blue-500 hover:underline">&larr; <FormattedMessage id="app.back_to_meted" defaultMessage="Back to MetEd" /></Link>
                </div>
                </div>

              </div>
              
            </form>

            <div className="block text-sm min-w-fit text-center mt-6"></div>

            <ForgotPasswordModal isOpen={forgotPwModalOpen} toggleModal={handleForgotPasswordModalToggle} />  

          </div>
        </div>


          
      </div>
    );
  }
};

function mapStateToProps({viewer, user}) {
	return { viewer, user }
}

export default connect(mapStateToProps)(SignInForm);